module.exports = __webpack_public_path__ + "static/media/12.76258d22.jpg";